/* ========================================
   DICA SIMPLES PARA FORMULÁRIO DE PRESCRIÇÃO
   LensShop - Novembro 2025
   ======================================== */

(function() {
  'use strict';
  
  // Aguardar DOM carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPrescriptionTip);
  } else {
    addPrescriptionTip();
  }
  
  function addPrescriptionTip() {
    // Aguardar app de prescrição carregar
    setTimeout(function() {
      // Tentar encontrar o container do formulário de prescrição
      const selectors = [
        '[class*="prescription"]',
        '[id*="prescription"]',
        'form[class*="product"]',
        '.product-form'
      ];
      
      let prescriptionContainer = null;
      
      for (let selector of selectors) {
        prescriptionContainer = document.querySelector(selector);
        if (prescriptionContainer) {
          // Verificar se realmente tem campos de prescrição
          const hasFileInput = prescriptionContainer.querySelector('input[type="file"]');
          const hasPrescriptionFields = prescriptionContainer.querySelector('[name*="sphere"], [name*="grau"], [name*="prescription"]');
          
          if (hasFileInput || hasPrescriptionFields) {
            break;
          } else {
            prescriptionContainer = null;
          }
        }
      }
      
      if (!prescriptionContainer) {
        console.log('LensShop: Container de prescrição não encontrado');
        return;
      }
      
      // Verificar se dica já foi adicionada
      if (prescriptionContainer.querySelector('.prescription-tip')) {
        return;
      }
      
      // Criar elemento da dica
      const tipElement = document.createElement('div');
      tipElement.className = 'prescription-tip';
      tipElement.innerHTML = `
        <p>
          <strong>💡 Dica:</strong> Não sabe seu grau? Envie uma foto da sua receita médica! 
          É mais rápido e evita erros.
        </p>
      `;
      
      // Inserir no início do container
      prescriptionContainer.insertBefore(tipElement, prescriptionContainer.firstChild);
      
      console.log('✓ LensShop: Dica de prescrição adicionada');
      
    }, 500);
  }
  
})();
